import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, LoadingMessages } from "src/app/common/Const";
import { GC_D2016_CORR_SLIP } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { ReqSpmt10331DetailSearch } from "src/app/request/req-spmt10331-search";
import { Spmt10331DetailSearchRowDto } from "src/app/response/rsp-spmt10331-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";

export enum ColumnIds {
  SlipLineNo = "slipLineNo",
  ProductCd = "productCd",
  StandardNm = "standardNm",
  DisposalReasonNm = "disposalReasonNm",
  DtQty = "dtQty",
  CostExc = "costExc",
  SellPriceExc = "sellPriceExc",
  SlipDtlComment = "slipDtlComment",
  SlipDtlApproverComment = "slipDtlApproverComment",
  ProductNm = "productNm",
  CostAmtExc = "costAmtExc",
  SellPriceAmtExc = "sellPriceAmtExc",
}

export enum ColumnHeaders {
  SlipLineNo = "伝票行番号",
  ProductCd = "商品コード",
  StandardNm = "規格",
  DisposalReasonNm = "廃棄理由",
  DtQty = "数量",
  CostExc = "原単価(抜)",
  SellPriceExc = "売単価(抜)",
  SlipDtlComment = "伝票詳細コメント",
  SlipDtlApproverComment = "伝票詳細承認者コメント",
  ProductNm = "商品名称",
  CostAmtExc = "原価金額(抜)",
  SellPriceAmtExc = "売価金額(抜)",
}

interface TableRow extends Spmt10331DetailSearchRowDto {}
@Component({
  selector: "spmt10331-detail-dialog",
  templateUrl: "./spmt10331-detail-dialog.component.html",
  styleUrls: ["./spmt10331-detail-dialog.component.css"],
})
export class Spmt10331DetailDialogComponent implements OnInit, AfterViewInit {
  columnIdFirst: string[] = [
    ColumnIds.SlipLineNo,
    ColumnIds.ProductCd,
    ColumnIds.StandardNm,
    ColumnIds.DisposalReasonNm,
    ColumnIds.DtQty,
    ColumnIds.CostExc,
    ColumnIds.SellPriceExc,
    ColumnIds.SlipDtlComment,
    ColumnIds.SlipDtlApproverComment,
  ];
  columnIdSecond: string[] = [ColumnIds.ProductNm, ColumnIds.CostAmtExc, ColumnIds.SellPriceAmtExc];
  columnDefsItemsFirst: TableColumnDef[] = [
    { columnId: ColumnIds.SlipLineNo, header: ColumnHeaders.SlipLineNo, width: 70, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 105, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 85, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.DisposalReasonNm, header: ColumnHeaders.DisposalReasonNm, width: 85, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.DtQty, header: ColumnHeaders.DtQty, width: 75, align: Alginment.Right, rowspan: 2, numberPipe: "1.0-0" },
    { columnId: ColumnIds.CostExc, header: ColumnHeaders.CostExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.SellPriceExc, header: ColumnHeaders.SellPriceExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.SlipDtlComment, header: ColumnHeaders.SlipDtlComment, width: 180, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.SlipDtlApproverComment, header: ColumnHeaders.SlipDtlApproverComment, width: 180, align: Alginment.Left, rowspan: 2 },
  ];

  columnDefsItemsSecond: TableColumnDef[] = [
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 190, align: Alginment.Left, rowspan: 1, colspan: 2 },
    { columnId: ColumnIds.CostAmtExc, header: ColumnHeaders.CostAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SellPriceAmtExc, header: ColumnHeaders.SellPriceAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  itemTableWidth: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private readonly httpBasic: HttpBasicService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      isDisableRow: boolean;
      storeCd: string;
      systemSlipNo: string;
      slipNo: string;
      updDateTime: string;
      redBlackFlg: string;
    },
    public commonService: CommonService
  ) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  get GC_D2016_CORR_SLIP() {
    return GC_D2016_CORR_SLIP;
  }

  private fnSearch() {
    const req: ReqSpmt10331DetailSearch = {
      access: this.data.access,
      systemSlipNo: this.data.systemSlipNo,
      updDateTime: this.data.updDateTime,
      disableRow: this.data.isDisableRow,
      storeCd: this.data.storeCd,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10331DetailSearch(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.dataSource.data = res.rows.map((item) => ({
          ...item,
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  ngOnInit() {
    this.calcTableWidth();
    this.fnSearch();
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }
}
